import React , { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { NavigationRoutes } from '../../constant/Routes';
import { useLocation, useNavigate, useParams } from 'react-router-dom'; 
import AddMake from './components/AddMake';
import { makeLisitingRequest, deleteMake } from './redux/makeDispatcher';
import { getCategoryLisiting} from '../category/redux/categoryDispatcher';


function MakeListing({makeListing}) {
  const { id } = useParams(); // Get the ID from the URL
  var parentId = 0;
  if(id){
    var m = id.replace(":", "");
    if(m){
      parentId = m;
    }
    
  }

  const paginationModel = { page: 0, pageSize: 10 };
  const [categories, setCategories] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const makeListingHeading =[
    
    {
       field: "id", headerName: "NO", width: 40,
       renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
     },
  
    {
      
      field: "name", headerName: (parentId==0?"Make Name":"Model Name"), width: 150 
    },
   
    {
      field: "action",
      headerName: "Action",
      width: parentId==0?300:170,
      sortable: false,

      renderCell: (params,row) => (
        <div style={{ display: "flex", flexDirection: "row", gap: "4px",alignItems: "center",
          height: "100%" }}>
             

             {

parentId==0?<button
onClick={() => {
  console.log("veiw is called", params, row);
    navigate(NavigationRoutes.ADMIN_DASHBOARD+NavigationRoutes.VEHICLE_MODEL.replace(":id",`:${params.row.id}`));
}}
style={{
  backgroundColor: "#4CAF50",
  color: "white",
  border: "none",
  cursor: "pointer",
  borderRadius: "4px",
  fontSize: "10px",
  width: "100%",
  height: "24px",  // Increased height
  padding: "2px 5px", // Added padding
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}}
>
{"Model"}
</button>:<div></div>
             }
       
        <AddMake
          parentId={parentId}
          buttonLabel="Edit"
          editMode={true}
          makeData={params.row}
          categories={categories}
          data={makeListing.makeDetail}
        />
     

        <button
          onClick={() => handleDelete(params.row)}
          style={{
            backgroundColor: "#F44336",
            color: "white",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "10px",
            width: "100%",
            height: "24px",  // Increased height
            padding: "2px 5px", // Added padding
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Delete
        </button>
      </div>
      
      ),
    },
  ];

  
  const handleDelete = (row) => {
    console.log("Deleting Make ID:", row);
    Swal.fire({
      title: ``,
      html:
        "" +
        "Are you sure?" +
        "<br>" +
        `You want to Delete ${parentId==0?"make":"model"} "${row.name}"`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Delete`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(deleteMake(row.id, parentId));
      }
    });
  
  };



  const fetchedRef = React.useRef(false);

  React.useEffect(() => {
console.log("checking useeffect",parentId);


  if (!fetchedRef.current) {
      fetchedRef.current = true; // mark as fetched
  
      const fetchCategories = async () => {
        try {
          const result = await dispatch(getCategoryLisiting());
          var cat=result.filter(item => item.is_vehicle == 1)
          setCategories(cat);

          console.log("Fetched categories:",cat);
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
      };
  
      fetchCategories();
    }

    dispatch(makeLisitingRequest(parentId, true));
  }, [dispatch,parentId, location.pathname]);
  



  return (
    
    <Paper sx={{ height: "95%", width: '100%' }}>


{makeListing.categoryDetail==null?<div style={{padding:"10px", justifyItems:"end"}}> 
<AddMake parentId={parentId} buttonLabel={parentId==0?"Add Make":"Add Model"} categories={categories}
          data={makeListing.makeDetail}
/>
  </div>
  : <div >
     </div>
     
     }

   
         
      <DataGrid
        rows={makeListing.makeListing || []}
        columns={makeListingHeading || []}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 25]}
        rowHeight={80}
        loading = {makeListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}
        

      />
    </Paper>
  );
}

//Getting the state from the store
const mapStateToProps = (state) => {
  return {
    makeListing: state.makeReducer, // Add optional chaining
  };
};
//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    makeLisitingRequest: () => dispatch({"type":"GET_MAKE_REQUEST"}), // Corrected function name
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(MakeListing);
